import React from 'react';
import classNames from 'classnames';

export interface FooterLogoProps {
  className?: string;
  heading?: string;
  id?: string;
  imageAltText?: string;
  imageSource?: string;
  size: 'slim' | 'medium' | 'big';
}

const FooterLogo = ({ className, id, imageSource, imageAltText, heading, size }: FooterLogoProps): JSX.Element => {
  const footerLogoClasses = classNames(
    className,
    'usa-footer__logo',
    'grid-row',
    { 'grid-gap-2': size === 'slim' },
    { 'mobile-lg:grid-col-6 mobile-lg:grid-gap-2': size === 'medium' },
  );

  const logoChildClasses = classNames(
    { 'grid-col-auto': size === 'slim' },
    { 'mobile-lg:grid-col-auto': size === 'medium' },
  );

  return (
    <div id={id} className={footerLogoClasses}>
      {imageSource && imageAltText ? (
        <div className={logoChildClasses}>
          <img className="usa-footer__logo-img" src={imageSource} alt={imageAltText} />
        </div>
      ) : null}
      {heading ? (
        <div className={logoChildClasses}>
          <h3 className="usa-footer__logo-heading">{heading}</h3>
        </div>
      ) : null}
    </div>
  );
};

export default FooterLogo;
